import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { toRef } from "vue";
import { useHelpForTerm } from "@/stores/helpTermsStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ConfigurationMarkdown from "@/components/ObjectStore/ConfigurationMarkdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HelpTerm',
    props: {
        term: null
    },
    setup(__props) {
        const props = __props;
        const { loading, hasHelp, help } = useHelpForTerm(toRef(props, "term"));
        return { __sfc: true, props, loading, hasHelp, help, BAlert, LoadingSpan, ConfigurationMarkdown };
    }
});
